import BaseForm from '../base';
export class TripwiresForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
